(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-curated"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'vsViewedProducts';
    const readViewed = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const saveViewed = (ids) => { try { localStorage.setItem(KEY, JSON.stringify(ids.slice(0, 12))); } catch (e) {} };

    const fetchHtml = (url) => fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok ? r.text() : '')).then((t) => new DOMParser().parseFromString(t, 'text/html'));

    async function init(root) {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      const sectionId = root.dataset.sectionId;
      const productId = root.dataset.productId;
      const max = parseInt(root.dataset.max, 10) || 8;

      // remember this product for "Recently viewed"
      const viewed = readViewed().filter((id) => String(id) !== String(productId));
      const recentIds = viewed.slice(0, 12);
      saveViewed([productId, ...viewed]);

      // tabs
      root.querySelectorAll('[data-vs-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          root.querySelectorAll('[data-vs-tab]').forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
          root.querySelectorAll('[data-vs-panel]').forEach((p) => (p.hidden = p.dataset.vsPanel !== tab.dataset.vsTab));
        });
      });

      // ---- Curated for you ----
      const grid = root.querySelector('[data-vs-curated-grid]');
      try {
        const doc = await fetchHtml(`${root.dataset.recoUrl}?product_id=${productId}&limit=10&intent=${root.dataset.intent}&section_id=${sectionId}`);
        const seen = new Set([String(productId)]);
        const items = [...doc.querySelectorAll('[data-vs-curated-items] > li')].filter((li) => {
          const id = li.dataset.productId;
          if (seen.has(id)) return false;
          seen.add(id);
          return true;
        }).slice(0, max);
        grid.replaceChildren(...items);
        if (!items.length) root.querySelector('[data-vs-panel="curated"]').hidden = true;
      } catch (e) {
        grid.replaceChildren();
      }

      // ---- Recently viewed ----
      if (recentIds.length) {
        try {
          const q = recentIds.map((id) => 'id:' + id).join(' OR ');
          const doc = await fetchHtml(`${root.dataset.searchUrl}?q=${encodeURIComponent(q)}&type=product&section_id=${sectionId}`);
          const byId = new Map([...doc.querySelectorAll('[data-vs-recent-items] > li')].map((li) => [li.dataset.productId, li]));
          const ordered = recentIds.map((id) => byId.get(String(id))).filter(Boolean);
          if (ordered.length) {
            root.querySelector('[data-vs-recent-slider]').replaceChildren(...ordered);
            root.querySelector('[data-vs-tab="recent"]').hidden = false;
          }
        } catch (e) {}
      }

      const slider = root.querySelector('[data-vs-recent-slider]');
      root.querySelectorAll('[data-vs-slide]').forEach((b) => b.addEventListener('click', () => {
        slider.scrollBy({ left: Number(b.dataset.vsSlide) * slider.clientWidth * 0.9, behavior: 'smooth' });
      }));
    }

    const run = () => document.querySelectorAll('[data-vs-cur]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-inspired-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      const track = root.querySelector('[data-vs-marq-track]');
      const first = track.querySelector('.vs-marq__set');
      const speed = (parseFloat(root.dataset.speed) || 40) / 60; // px per frame at 60fps
      let paused = false, dragging = false, startX = 0, startScroll = 0, moved = false, pos = 0;

      const loop = () => {
        const half = first.offsetWidth;
        if (!paused && !dragging && !reduce) {
          pos += speed;
          if (pos >= half) pos -= half;
          track.scrollLeft = pos;
        } else {
          pos = track.scrollLeft;
          if (pos >= half) { pos -= half; track.scrollLeft = pos; }
        }
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);

      // pause while the shopper is looking or touching
      track.addEventListener('mouseenter', () => (paused = true));
      track.addEventListener('mouseleave', () => (paused = false));
      track.addEventListener('touchstart', () => (paused = true), { passive: true });
      track.addEventListener('touchend', () => setTimeout(() => (paused = false), 1500), { passive: true });
      track.addEventListener('focusin', () => (paused = true));
      track.addEventListener('focusout', () => (paused = false));

      // drag with the mouse on desktop
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        dragging = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false; pos = track.scrollLeft; track.classList.remove('is-dragging');
      });
      // a drag should not open a link
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    };
    const run = () => document.querySelectorAll('[data-vs-marq]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      const tabs = root.querySelectorAll('[data-vs-ptab]');
      const show = (id) => {
        tabs.forEach((t) => { const on = t.dataset.vsPtab === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
        root.querySelectorAll('[data-vs-ppanel]').forEach((p) => (p.hidden = p.dataset.vsPpanel !== id));
      };
      tabs.forEach((t) => t.addEventListener('click', () => show(t.dataset.vsPtab)));
      // Theme editor: selecting a tab block shows its panel
      root.addEventListener('shopify:block:select', (e) => { if (e.target.dataset.vsPtab) show(e.target.dataset.vsPtab); });
    };
    const run = () => document.querySelectorAll('[data-vs-ptabs]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
